import styled from 'styled-components'

export const EmptyContainer = styled.div`
  width: 1px;
`
